/* eslint-disable import/prefer-default-export */
import React from 'react';
import { NavLink, Route } from 'react-router-dom';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import useFeatureRoutes from '../RouteConfigurations/useFeatureRoutes';
import shouldShowSubMenu from './useShouldShowNestedMenus';
import styles from './navigation.module.css';
import { FlexWrapper } from '../../Shared/FlexWrapper';
import { IconColors } from '../../Icons';
import { NavigationLink } from '../Types/NavigationLink';

interface NavigationProps {
    features: NavigationLink[];
}

function SubMenuNav({ features }: NavigationProps): React.ReactElement {
    const { navigationLinks } = useFeatureRoutes(features);
    const namespaces = navigationLinks
        .map(({ text }) => (text.includes(':') ? text.split(':')[0] : undefined))
        .filter(Boolean);
    const { t } = useTranslation(namespaces);

    return (
        <nav className={classNames(styles.Navigation, styles.SubMenu)}>
            <ul>
                {navigationLinks.map(({ Icon, text, url, childItems }: NavigationLink) => (
                    <li key={`core-navigation-${url.replace('/', '').toLowerCase()}`} data-qa={`core-navigation-${text}`}>
                        <NavLink
                            data-qa-navigation-link={text}
                            className="dropdown-item"
                            to={url || ''}
                            activeClassName={styles.ActiveItem}
                        >
                            <FlexWrapper align="center" justify="start" gap="0.5rem">
                                <Route strict path={url}>
                                    {({ match }) => (
                                        <Icon aspect="1.25rem" color={match ? IconColors.LightGrey : IconColors.Grey} />
                                    )}
                                </Route>
                                <span>{t(text)}</span>
                            </FlexWrapper>
                        </NavLink>
                        {childItems?.length && shouldShowSubMenu(childItems, url) ? (
                            <SubMenuNav features={childItems} />
                        ) : (
                            <></>
                        )}
                    </li>
                ))}
            </ul>
        </nav>
    );
}
export default SubMenuNav;
